import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import SpaRoundedIcon from "@mui/icons-material/SpaRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import type { SvgIconComponent } from "@mui/icons-material";
import { ComponentHeader } from "@/components/ui";
import { PARTNERS_PAGE } from "@/constants/partners-page";

const ICONS: Record<string, SvgIconComponent> = {
  lock: LockRoundedIcon,
  receipt: ReceiptLongRoundedIcon,
  services: SpaRoundedIcon,
  bolt: BoltRoundedIcon,
};

export const PartnersBenefits = () => {
  const { benefits, audience } = PARTNERS_PAGE;

  return (
    <Container maxWidth="lg">
      <ComponentHeader title={benefits.title} subTitle={benefits.subtitle} component="h2" />

      <Grid container spacing={3}>
        {benefits.items.map((item) => {
          const Icon = ICONS[item.icon] ?? LockRoundedIcon;
          return (
            <Grid key={item.title} size={{ xs: 12, sm: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  p: { xs: 3, md: 4 },
                  borderRadius: 4,
                  border: 1,
                  borderColor: "divider",
                  bgcolor: "background.paper",
                  transition: "border-color 0.2s ease, transform 0.2s ease",
                  "&:hover": { borderColor: "primary.light", transform: "translateY(-2px)" },
                }}
              >
                <Stack spacing={2}>
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "primary.light",
                      color: "primary.dark",
                    }}
                  >
                    <Icon />
                  </Box>
                  <Typography variant="h6" component="h3" sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    {item.body}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ textAlign: "center", maxWidth: 760, mx: "auto", mt: { xs: 6, md: 8 } }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 1.5 }}>
          {audience.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
          {audience.body}
        </Typography>
      </Box>
    </Container>
  );
};
